import React from 'react';
import { Container, Typography, Box, Button, Stack, Avatar, Card, CardContent } from '@mui/material';
import { BuildOutlined, BookOutlined, AccountCircleOutlined, ArticleOutlined, EmailOutlined } from '@mui/icons-material';
import Header from '../components/blog/components/Header';
import Footer from '../components/blog/components/Footer';
import AppTheme from '../components/shared-theme/AppTheme';
import { ThemeProvider, createTheme, useColorScheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { env, fetchGithub, fetchResume } from '../services/AppService';
import Grid from '@mui/material/Grid2';
import { projectData } from '../data';
import Link from '@mui/material/Link';
import { GitHub, LinkedIn, LocationOn } from '@mui/icons-material';
import CardActions from '@mui/material/CardActions';
import CardActionArea from '@mui/material/CardActionArea';
import { alpha, styled } from '@mui/material/styles';
import CardMedia from '@mui/material/CardMedia';

const StyledCard = styled(Card)(({ theme }) => ({
	p: 2,
	textAlign: 'center',
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	height: '23vh',
	borderRadius: '41px',
	maxWidth: '360px'
}));

function LocationCard()
{
	return (
		<>
		<StyledCard>
		<CardActionArea sx={{
			justifyContent: 'center',
			alignItems: 'center',
			display: 'flex',
			flexGrow: 1
		}}>
		<CardContent>
			<LocationOn fontSize='large' color="primary" />
			<Typography>San Francisco Bay Area, U.S.</Typography>
		</CardContent>
		</CardActionArea>
		</StyledCard>
		</>
	);
}

const githubImg = 'github-mark-white.svg'
const linkedinImg = 'LI-Logo.png'

const handleClick = (url) => {
	if (url) {
		window.open(url, '_blank', 'noopener,noreferrer');
	} else {
		window.location.href = '/404';
	}
};

function SocialCard({ img, str, url })
{
	return (
		<StyledCard>
		<CardActionArea
			onClick={() => handleClick(url)}
			sx={{
			justifyContent: 'center',
			alignItems: 'center',
			display: 'flex',
			flexGrow: 1,
			}}
		>
		<Stack spacing={2} direction='column'>
		<Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'center', alignItems: 'center' }}>
		<CardMedia
			component='img'
			image={`${env.DOMAIN}/static/img/${img}`}
			alt='social media image'
			sx={{
				flex: '0 2 80%',
			}}
		/>
		</Box>
		<CardContent sx={{ textAlign: 'center' }}>
			<Typography
				sx={{
					fontSize: 'large',
				}}
			>
				{str}
				{/*Visit My GitHub Profile*/}
			</Typography>
		</CardContent>
		</Stack>
		</CardActionArea>
		</StyledCard>
	);
}

export default function ContactPage(props)
{
	return (
		<>
		<AppTheme {...props}>
		<CssBaseline enableColorScheme />
		<Header />
		<Container
			maxWidth='lg'
			component='main'
			sx={{ display: 'flex', flexDirection: 'column', my: 16, gap: 4 }}
		>
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 4}}>
      		<div>
      		  <Typography variant="h1" textAlign='center' gutterBottom>
      		    Contact
      		  </Typography>
			  <Typography variant='h6' textAlign='center' color='text.secondary'>
				Contact me on social media!
			  </Typography>
      		</div>

		{/*height: '50vh',*/}
    	<Stack 
			spacing={2}
			alignItems="center"
			sx={{
				justifyContent: 'center',
				display: 'flex',
			}}
		>

    	  {/* Avatar */}
    	  <Avatar 
				alt='Asuka Langley Soryu'
				src={`${env.DOMAIN}/static/img/asuka-profile.jpg`}
				sx={{ 
					height: '20vh',
					width: '20vh',
				}}
			/>


    	  {/* Cards Section */}
    	  {/* Social Links */}
    	  <Stack
			direction="row" 
			spacing={4}
			alignItems="center"
			justifyContent='center'
			sx={{
				height: '33vh',
				width: '100%',
			}}
			>
				<SocialCard img={githubImg}
					str = 'Visit My GitHub Profile'
					url = 'https://github.com/agge3'
				/>
				<SocialCard img={linkedinImg}
					str = 'Connect with Me on LinkedIn'
					url = 'https://www.linkedin.com/in/baxtertyler'
				/>
    	  </Stack>
    	</Stack>

		</Box>

		</Container>
		<Footer />
		</AppTheme>
		</>
	);
}
